import slick from 'slick-carousel/slick/slick.min.js';
import slickLightbox from 'slick-lightbox/dist/slick-lightbox.min.js';

export default {
  init() {

    jQuery('.slider').slick({
      dots: true,
      prevArrow: jQuery('.arrow__prev'),
      nextArrow: jQuery('.arrow__next'),
    });

    jQuery('.slider').slickLightbox({
      itemSelector: '.slider__item > a',
      slick: {
        prevArrow: '<button type="button" class="slick-arrow slick-prev"><span class="sr-only">Eelmine</span></button>',
        nextArrow: '<button type="button" class="slick-arrow slick-next"><span class="sr-only">Järgmine</span></button>',
      },
    });

  },
};


// WEBPACK FOOTER //
// ./scripts/routes/single-referents.js